/**
 * AdministradorCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Administrador} from '@/model/resource/Administrador'

/* TODO: review generated class */
@HttpExclude()
export class AdministradorCollection extends PageCollection<Administrador> {
  constructor() {
    super(Administrador)
  }

  queryAsPage() {
    return this.listAdministrador()
  }

  async listAdministrador() {
    return await Request.get(`/admin/administrador`, {params: this.params})
      .name('listAdministrador')
      .as(this)
      .getResponse()
  }

  async listCsvAdministrador() {
    return await Request.get(`/admin/administrador/csv`, {params: this.params})
      .name('listCsvAdministrador')
      .as(this)
      .getResponse()
  }
}
